import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useRESTFetcher } from '../../../../api/useRESTFetcher';
import { API_URL } from '../../../../config/endpoints';

export interface SubmitOnlineSchedulerDigitalFormBody {
  uuid: string;
  responseJson: Record<string, any>;
}

interface Response {
  status: number;
  message?: string;
}

export const useSubmitOnlineSchedulerDigitalForm = <TError = unknown, TContext = unknown>(
  op: { opcode: string },
  inputProps?: UseMutationOptions<Response, TError, SubmitOnlineSchedulerDigitalFormBody, TContext>
) => {
  const { koiFetch } = useRESTFetcher();
  const postSubmit = async ({ uuid, responseJson }: SubmitOnlineSchedulerDigitalFormBody): Promise<Response> => {
    return koiFetch(`${API_URL}/forms/submitOsResponse`, {
      method: 'POST',
      body: JSON.stringify({ uuid, responseJson }),
    });
  };

  return useMutation<Response, TError, SubmitOnlineSchedulerDigitalFormBody, TContext>({
    mutationFn: postSubmit,
    ...inputProps,
    onError: () => {
      console.error(`OPCODE: ${op.opcode}`);
    },
  });
};
